import { useEffect, useRef } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { TENANT_ID } from '@/lib/supabase'

/** Bounded first-party measurements; no URLs, queries, customer contents or browser fingerprint. */
export default function PerformanceMonitor() {
  const { session, isLoading, isAdmin, isSalesperson, b2bCustomer } = useAuth()
  const auth = useRef({ session, enabled: false })
  auth.current = { session, enabled: !isLoading && (isAdmin || isSalesperson || b2bCustomer?.status === 'approved') }
  useEffect(() => {
    if (!import.meta.env.PROD) return
    try { if (localStorage.getItem('b2b_disable_telemetry') === '1') return } catch { return }
    let disposed = false
    const firstScreen = location.pathname.split('/')[1]
    const screen = ['login', 'catalogo', 'carrinho', 'checkout', 'pedidos', 'perfil', 'admin', 'vendedor', 'proposta'].includes(firstScreen) ? firstScreen : 'outro'
    const device = innerWidth < 1024 ? 'mobile' : 'desktop'
    const sent = new Set<string>()
    const timer = window.setTimeout(() => {
      void import('web-vitals').then(({ onLCP, onINP, onCLS }) => {
        if (disposed) return
        const report = ({ name, value, id }: { name: string; value: number; id: string }) => {
          if (disposed || !auth.current.enabled || !auth.current.session || !Number.isFinite(value) || sent.has(id) || sent.size >= 9) return
          sent.add(id)
          void fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/rpc/b2b_record_web_vital`, {
            method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/json', apikey: import.meta.env.VITE_SUPABASE_ANON_KEY, Authorization: `Bearer ${auth.current.session.access_token}` },
            body: JSON.stringify({ p_tenant_id: TENANT_ID, p_payload: { metric: name, value, measurement_id: crypto.randomUUID(), device, screen } }),
          }).catch(() => { /* Performance collection must never block a purchase. */ })
        }
        onLCP(report); onINP(report); onCLS(report)
      }).catch(() => {})
    }, 1200)
    return () => { disposed = true; clearTimeout(timer) }
  }, [])
  return null
}
